import { ISysPermissions } from "../interface/sys-permissions";
import axiosInstance from "./instance";

export const RequestGetSysPermissionss = (addNotification: any, data?: any): Promise<ISysPermissions[]> => {
    return new Promise<ISysPermissions[]>((resolve, reject) => {
        let url = `/sysPermissionss/`;
        if (data) {
            url += "?";
            for (let [key, value] of Object.entries(data)) {
                url += key + '=' + value + "&";
            }
        }
        axiosInstance(addNotification).get(url).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            // console.log(response);
            resolve(response)

        }).catch(exc => {
            // console.log(exc);
            reject(exc);
        });
    })
}

export const RequestGetSysPermissions = (addNotification: any, id: string): Promise<ISysPermissions> => {
    return new Promise<ISysPermissions>((resolve, reject) => {

        axiosInstance(addNotification).get(`/sysPermissionss/${id}`).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            //  console.log(response);
            resolve(response)

        }).catch(exc => {
            //   console.log(exc);
            reject(exc);
        });
    })
}


export const RequestNewSysPermissions = (addNotification: any, thing: ISysPermissions): Promise<ISysPermissions> => {
    return new Promise<ISysPermissions>((resolve, reject) => {

        axiosInstance(addNotification).post(`/sysPermissionss/`, thing).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            console.log(response);
            resolve(response)

        }).catch(exc => {
            console.log(exc);
            reject(exc);
        });
    })
}
export const RequestDeleteSysPermissions = (addNotification: any, thing: ISysPermissions): Promise<boolean> => {
    return new Promise<boolean>((resolve, reject) => {

        axiosInstance(addNotification).delete(`/sysPermissionss/delete/${thing.id}`).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            console.log(response);
            resolve(response)

        }).catch(exc => {
            console.log(exc);
            reject(exc);
        });
    })
}
export const RequestUpdateSysPermissions = (addNotification: any, user: ISysPermissions): Promise<ISysPermissions> => {
    return new Promise<ISysPermissions>((resolve, reject) => {

        axiosInstance(addNotification).patch(`/sysPermissionss/${user.id}`, user).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            console.log(response);
            resolve(response)

        }).catch(exc => {
            console.log(exc);
            reject(exc);
        });
    })
}

export const RequestSysPermissionsFunction = (addNotification: any, func:string, id: string): Promise<any[]> => {
    return new Promise<any[]>((resolve, reject) => {
        let url = `/sysPermissionss/${func}/${id}`;
        
        axiosInstance(addNotification).get(url).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            // console.log(response);
            resolve(response)

        }).catch(exc => {
            // console.log(exc);
            reject(exc);
        });
    })
}

// eslint-disable-next-line
{/*<!-- OPTIONAL 1 -->*/ }

// eslint-disable-next-line
{/*<!-- OPTIONAL END -->*/ }
